/* ELVYNECO — panier global (habillage du tiroir Moonbundle). Fichier du thème : assets/elv-cart-ui.js
 * UI / affichage uniquement : aucune logique business (prix, SKU, variantes, plans, quantités, cadeaux, checkout).
 * Générique : fonctionne pour tout produit (avec/sans prix barré, avec/sans cadeau Moonbundle, avec/sans abonnement).
 * Configuration (icônes, réassurance, livraison offerte, protection, ordre des paiements) : snippets/elv-cart-config.liquid → window.ELV_CART_CONFIG.
 * Textes : clés de traduction elv.* via window.ELV_I18N et ELV_CART_CONFIG. Aucun texte client dans ce fichier.
 * Activé seulement si la configuration et les clés existent (sinon le panier Moonbundle natif reste inchangé).
 */
(function () {
  if (window.__elvCartGlobal) return; window.__elvCartGlobal = true;
  var KEYS = ['cart_title', 'cart_you_save', 'cart_total', 'cart_checkout', 'cart_free'];
  var PAY_W = 26, PAY_GAP = 4;
  var dec = document.createElement('textarea');
  function T(k) { var d = window.ELV_I18N; if (!d || typeof d[k] !== 'string' || !d[k]) return null; dec.innerHTML = d[k]; return dec.value; }
  function cfg() { return window.ELV_CART_CONFIG || null; }
  function ready() { var c = cfg(); if (!c || !c.icons) return false; for (var i = 0; i < KEYS.length; i++) if (!T(KEYS[i])) return false; return true; }
  function decode(s) { dec.innerHTML = s || ''; return dec.value; }

  /* icône : SVG inline (currentColor) ou URL d'image ; vide = pas d'icône */
  function ico(name, extra) {
    var c = cfg(), v = c && c.icons && c.icons[name]; if (!v) return '';
    v = String(v).trim(); var inner = '';
    if (/^<svg[\s>]/i.test(v)) inner = v;
    else if (/^(https?:)?\/\//i.test(v) || v.charAt(0) === '/') inner = '<img src="' + v.replace(/"/g, '&quot;') + '" alt="" loading="lazy">';
    else return '';
    return '<span class="elv-ico ' + (extra || '') + '" aria-hidden="true">' + inner + '</span>';
  }

  var CSS = [
    '[data-elv-ui] .moonbundle-cart-drawer-content{background:#fff}',
    '[data-elv-ui][data-elv-empty="1"] .elv-ship,[data-elv-ui][data-elv-empty="1"] .moonbundle-cart-footer{display:none!important}',
    '[data-elv-ui] .elv-ico{display:inline-flex;flex:none}',
    '[data-elv-ui] .elv-ico svg,[data-elv-ui] .elv-ico img{width:100%;height:100%;display:block;object-fit:contain}',
    '[data-elv-ui] .moonbundle-cart-drawer-header{padding:14px 16px 10px;border-bottom:0}',
    '[data-elv-ui] .moonbundle-cart-drawer-header-title,[data-elv-ui] .moonbundle-cart-drawer-header-item-count{display:none!important}',
    '[data-elv-ui] .elv-head{font-size:18px;font-weight:600;color:#1B2A21;letter-spacing:.2px}',
    '[data-elv-ui] .elv-ship{margin:0 16px 12px}',
    '[data-elv-ui] .elv-ship-row{display:flex;align-items:center;gap:10px;font-size:12.5px;font-weight:500;line-height:1.25;letter-spacing:0;color:#1B2A21}',
    '[data-elv-ui] .elv-ship-row .elv-ico{width:26px;height:26px;color:#4B7C59}',
    '[data-elv-ui] .elv-ship-bar{height:6px;border-radius:99px;background:linear-gradient(90deg,#7DAE8B,#4B7C59);margin-top:9px}',
    '[data-elv-ui] .moonbundle-cart-body-items{padding:0 16px}',
    '[data-elv-ui] .moonbundle-cart-item{border:1px solid #E3EAE5;border-radius:12px;background:#fff;box-shadow:none}',
    '[data-elv-ui] [data-elv="main"] .moonbundle-cart-item-details{display:flex;flex-direction:column}',
    '[data-elv-ui] [data-elv="main"]:not([data-elv-known]) .moonbundle-cart-item-details{visibility:hidden}',
    '[data-elv-ui] [data-elv="main"] .moonbundle-cart-item-title{order:0;margin:0}',
    '[data-elv-ui] [data-elv="main"] .moonbundle-cart-item-title,[data-elv-ui] [data-elv="main"] .moonbundle-cart-item-title-link{font-size:14.5px!important;font-weight:700!important;line-height:1.25!important;color:#1B2A21!important}',
    '[data-elv-ui] [data-elv="main"] .moonbundle-product-options{order:1}',
    '[data-elv-ui] [data-elv="main"] .moonbundle-product-options-values{font-size:12px;font-weight:400;color:#4A5850;line-height:1.3}',
    '[data-elv-ui] [data-elv-bundle="1"] .moonbundle-cart-item-title{display:none!important}',
    '[data-elv-ui] [data-elv-bundle="1"] .moonbundle-product-options-values{font-size:15px;font-weight:700;color:#1B2A21;line-height:1.25}',
    '[data-elv-ui] [data-elv="main"] .elv-cart-freq{order:2;font-size:12px!important;color:#4A5850!important;margin:2px 0 6px!important}',
    '[data-elv-ui] [data-elv="main"] .moonbundle-cart-containerQuantityAndDeleteBtn{order:3}',
    '[data-elv-ui] .elv-save-pill{display:inline-block;margin-top:4px;padding:2px 7px;border-radius:4px;background:#4B7C59;color:#fff;font-size:11px;font-weight:700;letter-spacing:.2px;white-space:nowrap}',
    '[data-elv-ui] .moonbundle-cart-item-price-container{text-align:right}',
    '[data-elv-ui] [data-elv="gift"]{margin:-4px 0 6px 16px;padding:0!important;border:0;border-radius:8px;background:#F4F8F5;position:relative}',
    '[data-elv-ui] [data-elv="gift"]::before{content:"";position:absolute;left:-12px;top:-10px;width:10px;height:26px;border-left:2px solid #B7CDBD;border-bottom:2px solid #B7CDBD;border-bottom-left-radius:8px}',
    '[data-elv-ui] [data-elv="gift"] .moonbundle-cart-item-container{display:flex!important;align-items:center;gap:8px;padding:4px 8px!important;min-height:0!important}',
    '[data-elv-ui] [data-elv="gift"] .moonbundle-cart-item-image-container{width:32px!important;min-width:32px!important;height:32px!important;margin:0!important;padding:0!important}',
    '[data-elv-ui] [data-elv="gift"] .moonbundle-cart-item-image{width:32px!important;height:32px!important;border-radius:6px;object-fit:cover}',
    '[data-elv-ui] [data-elv="gift"] .moonbundle-cart-item-details{flex:1 1 auto;min-width:0;display:flex!important;flex-direction:row!important;align-items:center;gap:4px;padding:0!important;margin:0!important}',
    '[data-elv-ui] [data-elv="gift"] .moonbundle-cart-item-title{flex:1 1 auto;min-width:0;margin:0!important}',
    '[data-elv-ui] [data-elv="gift"] .moonbundle-cart-item-title-link{display:-webkit-box!important;-webkit-line-clamp:2!important;-webkit-box-orient:vertical!important;overflow:hidden!important}',
    '[data-elv-ui] [data-elv="gift"] .moonbundle-cart-item-title,[data-elv-ui] [data-elv="gift"] .moonbundle-cart-item-title-link{font-size:11px!important;line-height:1.3!important;font-weight:600!important}',
    '[data-elv-ui] [data-elv="gift"] .moonbundle-cart-containerQuantityAndDeleteBtn,[data-elv-ui] [data-elv="gift"] .moonbundle-cart-item-remove-container{width:auto!important;margin:0!important;padding:0!important}',
    '[data-elv-ui] [data-elv="gift"] .moonbundle-cart-item-quantity-container,[data-elv-ui] [data-elv="gift"] .moonbundle-free-gift-badge,[data-elv-ui] [data-elv="gift"] .moonbundle-cart-item-gift-text,[data-elv-ui] [data-elv="gift"] .moonbundle-cart-item-gift-icon,[data-elv-ui] [data-elv="gift"] .moonbundle-cart-item-price{display:none!important}',
    '[data-elv-ui] [data-elv="gift"] .moonbundle-cart-item-remove{transform:scale(.7);margin:0!important;padding:0!important}',
    '[data-elv-ui] [data-elv="gift"] .moonbundle-cart-item-price-container{flex:none;display:flex!important;flex-direction:column!important;align-items:flex-end;gap:0;margin:0!important;padding:0!important}',
    '[data-elv-ui] [data-elv="gift"] .moonbundle-cart-item-prices{margin:0!important;padding:0!important}',
    '[data-elv-ui] [data-elv="gift"] .moonbundle-cart-item-original-price{font-size:10.5px!important}',
    '[data-elv-ui] .elv-gift-free{display:block;order:-1;margin:0;font-size:11px;font-weight:800;line-height:1.2;color:#2F5A3E;letter-spacing:.4px}',
    '[data-elv-ui] .moonbundle-cart-footer{background:#fff}',
    '[data-elv-ui] .moonbundle-cart-drawer-footer{display:flex;flex-direction:column;padding:10px 16px 12px;background:#fff;border-top:1px solid #E3EAE5}',
    '[data-elv-ui] .moonbundle-toggle-upsell-section{order:1}',
    '[data-elv-ui][data-elv-protect="1"] .moonbundle-toggle-upsell-section,[data-elv-ui][data-elv-protect="p"] .moonbundle-toggle-upsell-section{display:none!important}',
    '[data-elv-ui] .moonbundle-cart-drawer-subtotal{display:none!important}',
    '[data-elv-ui] .elv-sum{order:2;margin:8px 0 10px}',
    '[data-elv-ui] .elv-sum-row{display:flex;align-items:center;justify-content:space-between;gap:8px}',
    '[data-elv-ui] .elv-sl{flex:none;font-size:14px;font-weight:700;letter-spacing:.5px;text-transform:uppercase;color:#1B2A21}',
    '[data-elv-ui] .elv-sbadge{flex:0 1 auto;min-width:0;text-align:center;text-wrap:balance;background:#E4F0E7;color:#2F5A3E;font-size:9.5px;font-weight:700;letter-spacing:.3px;text-transform:uppercase;line-height:1.15;padding:3px 7px;border-radius:4px}',
    '[data-elv-ui] .elv-fin{flex:none;font-size:20px;font-weight:800;color:#1B2A21;white-space:nowrap}',
    '[data-elv-ui] .moonbundle-cart-drawer-checkout{order:3;position:relative;display:block;width:100%;min-height:48px;height:auto;padding:0 44px;border:0;border-radius:8px;background:#4B7C59!important;color:#fff!important;font-size:0!important;cursor:pointer}',
    '[data-elv-ui] .moonbundle-cart-drawer-checkout>*:not(.elv-cta){display:none!important}',
    '[data-elv-ui] .elv-cta{display:flex;align-items:center;justify-content:center;min-height:48px;font-size:16px;font-weight:700;line-height:1.2;color:#fff;white-space:nowrap}',
    '[data-elv-ui] .elv-cta .elv-ico{position:absolute;top:50%;width:19px;height:19px;margin-top:-9.5px}',
    '[data-elv-ui] .elv-cta .elv-cta-lock{left:16px}',
    '[data-elv-ui] .elv-cta .elv-cta-arrow{right:16px}',
    '[data-elv-ui] .elv-pay{order:4;display:flex;flex-wrap:nowrap;justify-content:center;gap:' + PAY_GAP + 'px;margin:9px 0 0;overflow:hidden}',
    '[data-elv-ui] .elv-pay>span{flex:none;display:block;width:' + PAY_W + 'px;height:17px}',
    '[data-elv-ui] .elv-pay .elv-pay-icon{width:' + PAY_W + 'px;height:17px;display:block}',
    '[data-elv-ui] .elv-reassure{order:5;display:flex;justify-content:space-between;gap:8px;margin-top:9px;padding:0 2px;color:#4A5850;font-size:11px}',
    '[data-elv-ui] .elv-reassure>span{display:flex;align-items:center;gap:5px;white-space:nowrap}',
    '[data-elv-ui] .elv-reassure .elv-ico{width:15px;height:15px;color:#4B7C59}',
    '@media (max-width:400px){[data-elv-ui] .elv-reassure{font-size:10px;gap:4px;letter-spacing:0}[data-elv-ui] .elv-reassure>span{gap:3px}[data-elv-ui] .elv-reassure .elv-ico{width:13px;height:13px}}',
    '@media (max-width:360px){[data-elv-ui] .elv-cta{font-size:15px}}'
  ].join('\n');

  var NUM = /\d[\d.,\s  ]*\d|\d/;
  function parseMoney(s) {
    var m = (s || '').match(NUM); if (!m) return null;
    var tok = m[0], dm = tok.match(/([.,])(\d{2})$/), dsep = dm ? dm[1] : '';
    var cents = parseInt(tok.replace(/\D/g, ''), 10); if (isNaN(cents)) return null;
    if (!dm) cents *= 100;
    var tm = tok.match(/[.,\s  ]/g) || [];
    var tsep = ''; for (var i = 0; i < tm.length; i++) if (tm[i] !== dsep || (dm && i < tm.length - 1)) { tsep = tm[i]; break; }
    return { cents: cents, src: s, tok: tok, dsep: dsep, tsep: tsep };
  }
  function fmtLike(p, cents) {
    var neg = cents < 0; cents = Math.abs(cents);
    var whole = String(Math.floor(cents / 100)), frac = ('0' + (cents % 100)).slice(-2);
    if (p.tsep) whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, p.tsep);
    var tok = whole + (p.dsep ? p.dsep + frac : '');
    return p.src.replace(p.tok, (neg ? '-' : '') + tok);
  }
  function fmtPercent(pct) {
    try { return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'percent', maximumFractionDigits: 0 }).format(pct / 100); }
    catch (e) { return pct + '%'; }
  }
  function txt(el) { return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; }
  function setTxt(el, s) { if (el && el.textContent !== s) el.textContent = s; }
  function setHtmlOnce(el, key, html) { if (el.getAttribute('data-k') !== key) { el.setAttribute('data-k', key); el.innerHTML = html; } }

  function ensureStyle() {
    if (document.getElementById('elv-cart-css')) return;
    var st = document.createElement('style'); st.id = 'elv-cart-css'; st.textContent = CSS; document.head.appendChild(st);
  }

  var lines = {}, loadingLines = false;
  /* Protection transport : masquer l'option payante si la protection est déjà incluse dans la commande (config : ELV_CART_CONFIG.protection) */
  var tags = {};
  function ensureTags(handle) {
    if (!handle || handle in tags) return;
    tags[handle] = null;
    fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
      .then(function (p) { tags[handle] = (p && p.tags) || []; }).catch(function () { tags[handle] = []; }).then(schedule);
  }
  function protectionState(drawer, P) {
    var vids = (P.includedVariantIds || []).map(String), tag = P.includedTag || '';
    var included = false, pending = false;
    drawer.querySelectorAll('.moonbundle-cart-item[data-item-key]').forEach(function (it) {
      if (it.querySelector('.moonbundle-free-gift-badge')) return;
      var L = lines[it.getAttribute('data-item-key')];
      if (!L) { pending = true; return; }
      if (vids.indexOf(String(L.variant)) > -1) included = true;
      if (tag) { ensureTags(L.handle); var t = tags[L.handle]; if (t === null || t === undefined) pending = true; else if (t.indexOf(tag) > -1) included = true; }
    });
    return included ? '1' : (pending ? 'p' : '0');
  }
  function loadLines() {
    if (loadingLines) return; loadingLines = true;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var m = {};
      cart.items.forEach(function (i) {
        var meta = null; try { meta = JSON.parse((i.properties || {}).__moonbundle || 'null'); } catch (e) {}
        m[i.key] = { bundle: !!(meta && meta.type === 'bundle'), variant: i.variant_id, handle: i.handle };
      });
      lines = m;
    }).catch(function () {
      document.querySelectorAll('.moonbundle-cart-drawer .moonbundle-cart-item[data-item-key]').forEach(function (el) {
        var k = el.getAttribute('data-item-key'); if (!(k in lines)) lines[k] = { bundle: false };
      });
    }).then(function () { loadingLines = false; schedule(); });
  }

  function fitPay(pay, footer) {
    var w = footer.clientWidth - 32; if (w <= 0) return;
    var n = Math.max(1, Math.floor((w + PAY_GAP) / (PAY_W + PAY_GAP)));
    var kids = pay.children;
    for (var i = 0; i < kids.length; i++) { var d = i < n ? '' : 'none'; if (kids[i].style.display !== d) kids[i].style.display = d; }
  }

  function apply() {
    var drawer = document.querySelector('.moonbundle-cart-drawer');
    if (!drawer || !ready()) return;
    var C = cfg();
    ensureStyle();
    if (drawer.getAttribute('data-elv-ui') !== '1') drawer.setAttribute('data-elv-ui', '1');
    var content = drawer.querySelector('.moonbundle-cart-drawer-content'); if (!content) return;
    var emptyFlag = drawer.querySelector('.moonbundle-cart-item[data-item-key]') ? '0' : '1';
    if (drawer.getAttribute('data-elv-empty') !== emptyFlag) drawer.setAttribute('data-elv-empty', emptyFlag);

    var mainCount = 0, unknown = false;
    drawer.querySelectorAll('.moonbundle-cart-item[data-item-key]').forEach(function (it) {
      var key = it.getAttribute('data-item-key');
      var gift = !!it.querySelector('.moonbundle-free-gift-badge');
      var kind = gift ? 'gift' : 'main';
      if (it.getAttribute('data-elv') !== kind) it.setAttribute('data-elv', kind);
      var priceBox = it.querySelector('.moonbundle-cart-item-price-container');
      if (gift) {
        if (priceBox && !priceBox.querySelector('.elv-gift-free')) { var f = document.createElement('span'); f.className = 'elv-gift-free'; priceBox.appendChild(f); }
        setTxt(it.querySelector('.elv-gift-free'), T('cart_free'));
        return;
      }
      if (key in lines) {
        if (it.getAttribute('data-elv-known') !== '1') it.setAttribute('data-elv-known', '1');
        var b = lines[key].bundle ? '1' : '0'; if (it.getAttribute('data-elv-bundle') !== b) it.setAttribute('data-elv-bundle', b);
      } else unknown = true;
      var q = it.querySelector('.moonbundle-quantity-input');
      mainCount += q ? (parseInt(q.value, 10) || 1) : 1;
      var cur = parseMoney(txt(it.querySelector('.moonbundle-cart-item-price'))), old = parseMoney(txt(it.querySelector('.moonbundle-cart-item-original-price')));
      var pill = it.querySelector('.elv-save-pill');
      var pct = (cur && old && old.cents > cur.cents) ? Math.round((1 - cur.cents / old.cents) * 100) : 0;
      if (pct >= 1 && priceBox) {
        if (!pill) { pill = document.createElement('span'); pill.className = 'elv-save-pill'; priceBox.appendChild(pill); }
        setTxt(pill, '-' + fmtPercent(pct));
      } else if (pill) pill.remove();
    });
    if (unknown) loadLines();

    /* protection transport payante : masquée si protection déjà offerte ; jamais cochée automatiquement */
    var P = C.protection || {};
    var pstate = (P.hideWhenIncluded === false) ? '0' : protectionState(drawer, P);
    if (drawer.getAttribute('data-elv-protect') !== pstate) drawer.setAttribute('data-elv-protect', pstate);
    if (pstate === '1') {
      var cb = drawer.querySelector('.moonbundle-toggle-upsell-section input[type="checkbox"]');
      if (cb && cb.checked && !cb.__elvUn) { cb.__elvUn = true; cb.click(); setTimeout(function () { cb.__elvUn = false; }, 3000); }
    }

    var left = drawer.querySelector('.moonbundle-cart-drawer-header-left');
    if (left) {
      var head = left.querySelector('.elv-head');
      if (!head) { head = document.createElement('div'); head.className = 'elv-head'; left.insertBefore(head, left.firstChild); }
      setTxt(head, T('cart_title') + (mainCount ? ' • ' + mainCount : ''));
    }

    var hdr = drawer.querySelector('.moonbundle-cart-drawer-header');
    var ship = drawer.querySelector('.elv-ship');
    var S = C.shipping || {};
    if (S.enabled && S.text) {
      if (hdr && !ship) { ship = document.createElement('div'); ship.className = 'elv-ship'; hdr.insertAdjacentElement('afterend', ship); }
      if (ship) {
        setHtmlOnce(ship, (S.icon || '') + '|' + (C.icons && C.icons[S.icon] || ''), '<div class="elv-ship-row">' + ico(S.icon) + '<span class="elv-ship-t"></span></div><div class="elv-ship-bar"></div>');
        setTxt(ship.querySelector('.elv-ship-t'), decode(S.text));
      }
    } else if (ship) ship.remove();

    var footer = drawer.querySelector('.moonbundle-cart-drawer-footer');
    var finalEl = drawer.querySelector('#moonbundle-cart-subtotal'), origEl = drawer.querySelector('.moonbundle-cart-subtotal-originalPrice');
    var cta = drawer.querySelector('.moonbundle-cart-drawer-checkout');
    if (!footer || !finalEl || !cta) return;
    var fin = txt(finalEl), orig = txt(origEl);
    var pf = parseMoney(fin), po = parseMoney(orig);
    var hasSave = !!(pf && po && po.cents > pf.cents);

    var sum = footer.querySelector('.elv-sum');
    if (!sum) {
      sum = document.createElement('div'); sum.className = 'elv-sum';
      sum.innerHTML = '<div class="elv-sum-row"><span class="elv-sl"></span><span class="elv-sbadge"></span><span class="elv-fin"></span></div>';
      footer.appendChild(sum);
    }
    setTxt(sum.querySelector('.elv-sl'), T('cart_total'));
    var badge = sum.querySelector('.elv-sbadge');
    if (badge.style.display !== (hasSave ? '' : 'none')) badge.style.display = hasSave ? '' : 'none';
    if (hasSave) setTxt(badge, T('cart_you_save') + ' ' + fmtLike(pf, po.cents - pf.cents));
    setTxt(sum.querySelector('.elv-fin'), fin);

    var c = cta.querySelector('.elv-cta');
    var want = T('cart_checkout') + ' · ' + fin;
    if (!c) { c = document.createElement('span'); c.className = 'elv-cta'; c.innerHTML = '<span class="elv-cta-slot-l"></span><span class="elv-cta-t"></span><span class="elv-cta-slot-r"></span>'; cta.appendChild(c); }
    setHtmlOnce(c.querySelector('.elv-cta-slot-l'), 'l' + ((C.icons && C.icons.lock) || ''), ico('lock', 'elv-cta-lock'));
    setHtmlOnce(c.querySelector('.elv-cta-slot-r'), 'r' + ((C.icons && C.icons.arrow) || ''), ico('arrow', 'elv-cta-arrow'));
    setTxt(c.querySelector('.elv-cta-t'), want);
    if (cta.getAttribute('aria-label') !== want) cta.setAttribute('aria-label', want);

    var pay = footer.querySelector('.elv-pay');
    var tpl = document.getElementById('elv-pay-icons');
    if (!pay && tpl && tpl.content && tpl.content.querySelector('svg')) {
      pay = document.createElement('div'); pay.className = 'elv-pay';
      var prio = C.paymentPriority || [];
      var nodes = Array.prototype.slice.call(tpl.content.querySelectorAll('[data-pay]'));
      nodes.sort(function (a, b) {
        var ia = prio.indexOf(a.getAttribute('data-pay')), ib = prio.indexOf(b.getAttribute('data-pay'));
        return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
      });
      nodes.forEach(function (n) { pay.appendChild(n.cloneNode(true)); });
      footer.appendChild(pay);
    }
    if (pay) fitPay(pay, footer);

    var R = C.reassurance || [];
    var re = footer.querySelector('.elv-reassure');
    if (R.length) {
      if (!re) { re = document.createElement('div'); re.className = 'elv-reassure'; footer.appendChild(re); }
      var sig = R.map(function (r) { return r.icon + ':' + r.text + ':' + ((C.icons && C.icons[r.icon]) || ''); }).join('|');
      if (re.getAttribute('data-k') !== sig) {
        re.setAttribute('data-k', sig); re.innerHTML = '';
        R.forEach(function (r) { var s = document.createElement('span'); s.innerHTML = ico(r.icon) + '<b style="font-weight:500"></b>'; s.querySelector('b').textContent = decode(r.text); re.appendChild(s); });
      }
    } else if (re) re.remove();
  }

  var mo = null, sched = null;
  function schedule() { clearTimeout(sched); sched = setTimeout(function () { try { apply(); } catch (e) {} if (mo) mo.takeRecords(); }, 60); }
  var origFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) { p.then(function () { setTimeout(loadLines, 450); }, function () {}); }
    return p;
  };
  function init() {
    var d = document.querySelector('.moonbundle-cart-drawer');
    if (!d) { setTimeout(init, 800); return; }
    mo = new MutationObserver(schedule);
    mo.observe(d, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', schedule);
    loadLines(); schedule();
  }
  init();
})();
